import React from 'react';
import { Button } from 'react-bootstrap';
import "./ButtonNavLinkMobile.css";

const ButtonNavLinkMobile = ({ classname__link__mobile,text__navlink__mobile,number__blog,}) => {
    return (
        <Button 
            bsPrefix={classname__link__mobile} 
        >
            {text__navlink__mobile}   <span className='number__blog'></span>                
        </Button>
    );
};

export default ButtonNavLinkMobile;